import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { HttpClientModule } from "@angular/common/http";
import {
  MatDialogModule, MatTabsModule, MatProgressBarModule, MatTableModule, MatInputModule, MatDatepickerModule, MatNativeDateModule,
  MatFormFieldModule, MatButtonModule, MatCheckboxModule, MatGridListModule, MatCardModule,
  MatMenuModule, MatIconModule, MatToolbarModule, MatSidenavModule, MatListModule, MatSelectModule } from "@angular/material";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { LayoutModule } from "@angular/cdk/layout";
import { LogisticRoutingModule } from "./logistic-routing.module";
import { DeliveryPrincipalComponent } from "./delivery/principal/delivery-principal.component";
import { DeliveryDriverComponent } from "./delivery/driver/delivery-driver.component";
import { DeliveryIndicatorComponent } from "./delivery/indicator/delivery-indicator.component";
import { DeliveryOperativeComponent } from "./delivery/operative/delivery-operative.component";
import { DeliverySearchComponent } from "./delivery/search/delivery-search.component";
import { DeliveryStorerComponent } from "./delivery/storer/delivery-storer.component";
import { DeliveryOperativeDetailComponent } from "./delivery/operative/delivery-operative-detail.component";
import { AsideComponent } from "../aside/aside.component";
import { MapModule } from "../map/map.module";
import { CommonModule } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";
import { SharedModule } from "../../shared/shared.module";
import { DevolutionAddComponent } from './devolutions/devolution-add/devolution-add.component';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { DeliveryRequestTransferComponent } from './delivery/request/delivery-request-transfer.component';
import { FileDropModule } from "ngx-file-drop";

@NgModule({
  declarations: [
    DeliveryPrincipalComponent,
    DeliveryDriverComponent,
    DeliveryIndicatorComponent,
    DeliveryOperativeComponent,
    DeliveryOperativeDetailComponent,
    DeliverySearchComponent,
    DeliveryStorerComponent,
    AsideComponent,
    DevolutionAddComponent,
    DeliveryRequestTransferComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    MatDialogModule, MatTabsModule, MatProgressBarModule, MatTableModule, MatInputModule, MatDatepickerModule, MatNativeDateModule,
    MatFormFieldModule, MatButtonModule, MatCheckboxModule, MatGridListModule, MatCardModule,
    MatMenuModule, MatIconModule, LayoutModule, MatToolbarModule, MatSidenavModule, MatListModule, MatSelectModule,
    LogisticRoutingModule, MapModule, TranslateModule, SharedModule, NgxMaterialTimepickerModule.forRoot(), FileDropModule
  ],
  providers: [],
  exports: [
    DeliveryPrincipalComponent,
    AsideComponent
  ]
})
export class LogisticModule { }
